<template>
  <div class="issues-index">
    <page-header
      :title="pageTitle"
    >
    </page-header>

    <div class="issues-index__table">
      <v-data-table
        :headers="issuesTableHeaders"
        :items="issues"
        :options.sync="paginationOptions"
        :server-items-length="totals"
        :show-arrows="true"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100],
          'next-icon': 'mdi-menu-right',
          'prev-icon': 'mdi-menu-left',
          'disable-pagination': isDataLoading,
        }"
        :loading="isDataLoading"
        disable-sort
        no-data-text="No issues"
        no-results-text="No issues for that filters"
      >
        <template #item.title="{ item }">
          <router-link
            :to="{ name: 'issue-show', params: { issuesId: item.id } }"
            class="issues-index__link"
          >
            {{ item.title }}
          </router-link>
        </template>

        <template #item.id="{ value }">
          <span>{{ value }}</span>
        </template>

        <template #item.post_date="{ value }">
          <span class="nowrap">{{ value | tableDate }}</span>
        </template>

        <template #item.developer_name="{ value }">
          <span>{{ value }}</span>
        </template>

        <template #item.project_name="{ value }">
          <span>{{ value }}</span>
        </template>

        <template #item.status="{ value }">
          <span
            class="issues-index__status"
            :class="`issues-index__status--${value.replace(/ /g,'').toLowerCase()}`"
          >
            {{ value}}
          </span>
        </template>

        <template #item.action="{ item }">
          <v-menu left min-width="100">
            <template v-slot:activator="{ on }">
              <v-btn icon color="secondary" v-on="on">
                <v-icon large>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>

            <v-list dense elevation-2>
              <v-list-item link :to="{ name: 'issue-show', params: { issuesId: item.id } }">
                <v-list-item-title>Reply</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { issuesTableHeaders } from '@/helpers/tableHeaders';
import PageHeader from '@/components/PageHeader.vue';

export default {
  metaInfo: {
    title: 'Issues',
  },

  components: {
    PageHeader,
  },

  data() {
    return {
      issuesTableHeaders,
      pageTitle: 'Issues',
      isModalVisible: false,
    };
  },

  computed: {
    ...mapState('issues', [
      'totals',
      'issues',
      'pagination',
      'isDataLoading',
    ]),

    paginationOptions: {
      get() {
        return this.pagination;
      },
      set(val) {
        this.setPagination(val);
      },
    },
  },

  watch: {
    paginationOptions: {
      handler() {
        this.fetchIssues();
      },
      deep: true,
    },
  },

  created() {
    this.fetchIssues();
  },

  methods: {
    ...mapActions('issues', [
      'fetchIssues',
      'setPagination',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.issues-index {
  &__table {
    padding: 12px 16px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
  }

  &__status {
    font-size: 12px;
    background: $color--green;
    border-radius: 16px;
    color: #fff;
    padding: 4px 16px;
    text-transform: capitalize;
    white-space: nowrap;

    &--senttohr {
      background: $color--yellow;
    }
    &--completed {
      background: $color--green;
    }
    &--responded {
      background: $color--blue;
    }
  }

  &__link {
    text-decoration: unset !important;
    display: flex;
    align-items: center;
  }
}
</style>
